import { ShieldCheck, TrendingUp, Layers, Globe2 } from "lucide-react";
import { useLang } from "@/lib/i18n";

const ICONS = [ShieldCheck, TrendingUp, Layers, Globe2];

export const TrustRow = () => {
  const { t } = useLang();
  return (
    <section data-testid="trust-row" className="relative border-y border-white/5 bg-[#070C18]">
      <div className="mx-auto grid max-w-7xl grid-cols-2 gap-6 px-5 py-8 lg:grid-cols-4 lg:px-8">
        {t.trust.map((it, i) => {
          const Icon = ICONS[i];
          return (
            <div key={it.t} data-testid={`trust-item-${i}`} className="flex items-center gap-4">
              <Icon className="h-8 w-8 shrink-0 text-[#2F7BFF] drop-shadow-[0_0_12px_rgba(47,123,255,.7)]" strokeWidth={1.6} />
              <div>
                <div className="text-sm font-bold text-white sm:text-[15px]">{it.t}</div>
                <div className="text-xs text-slate-400 sm:text-sm">{it.d}</div>
              </div>
            </div>
          );
        })}
      </div>
    </section>
  );
};
